import { t } from "i18next";
import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { OverlayLoader } from "../../Components/Shimmers";
import { axiosGet } from "../../Apis/axiosMethods";

const { NavLink, useLocation } = require("react-router-dom")
const { ConfigContext } = require("../../Context/ConfigContext")

const Pages = ({ page }) => {
  const { apiB2BURL, token, lang } = useContext(ConfigContext);
  const { t } = useTranslation();
  const dir = localStorage.getItem('dir');
  const [PageContent, setPageContent] = useState();
  const [PageTitle, setPageTitle] = useState();
  const location = useLocation();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    LoadPolicyInfo();
    window.scrollTo(0, 0);
  }, [location]);

  const LoadPolicyInfo = async () => {

    try {

      setLoading(true);

      const response = await axiosGet(`/Dashboard/GetPages?page=${page}&lang=${lang ?? 'en'}`,);

      const row = response?.data?.data?.[0];

      if (row) {
        setPageContent(row.page_content);
        setPageTitle(row.page_name);
      }

    } catch (error) {

      console.error("LoadPolicyInfo Error:", error);

    } finally {

      setLoading(false); // ✅ Stop Loader

    }
  };


  return (
    <>
      {
        loading ?
          <div style={{ height: "70vh" }}>
            <OverlayLoader />
          </div>
          :
          <div>

            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <div className="container">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to={"/"}>
                      <i className="icon-home" /></NavLink>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">{PageTitle}</li>
                </ol>
              </div>
            </nav>
            <div className="about-section">

              <div className="row justify-content-center">
                <div className="col-8">
                  <h2>{PageTitle ?? '...'} </h2>
                  <iframe
                    srcDoc={PageContent}
                    style={{
                      width: '100%',
                      border: 'none',
                      height: 'auto',
                      minHeight: '500px'
                    }}
                    title={PageTitle}
                    onLoad={(e) => {
                      e.target.style.height =
                        e.target.contentWindow.document.documentElement.scrollHeight + 'px';
                    }}
                  />
                </div>
              </div>

            </div>

          </div>
      }
    </>
  )
}

export default Pages;